import { createStore, applyMiddleware, compose } from 'redux'


import ApiCall from 'utils/ApiCall'
import thunk from 'redux-thunk'

import rootReducers from '../reducer'

import config from '../../../config'

import promiseMiddleware from '../middleware/promiseMiddleware'
import shuttleMiddleware from '../middleware/shuttleMiddleware'


export default function configStore(initialState) {
  const shuttle = shuttleMiddleware()
  const promise = promiseMiddleware(new ApiCall())

  const middleware = [
    thunk,
    shuttle,
    promise,
  ]


  // eslint-disable-next-line no-underscore-dangle
  const enabledCompose = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
  const composeEnhancers = (config.env !== 'production') ? enabledCompose : compose

  const store = createStore(rootReducers, initialState, composeEnhancers(
    applyMiddleware(...middleware),
  ))

  if (module.hot) {
    module
      .hot
      .accept('../reducer', () => {
        // eslint-disable-next-line global-require
        const nextRootReducers = require('../reducer')

        store.replaceReducer(nextRootReducers)
      })
  }

  return store
}
